export const AuctionStatusType = {
  PHYSICAL: 'PHYSICAL',
  MINIMUM_PRICE: 'MINIMUM_PRICE',
  TRYING_TO_DEAL: 'TRYING_TO_DEAL',
  BUY_NOW_ONLY: 'BUY_NOW_ONLY',
};

export const AuctionStatusTypeName = {
  TRYING_TO_DEAL: 'Trying to Deal',
  MINIMUM_PRICE: 'No Reserve',
  PHYSICAL: 'Reserve',
  BUY_NOW_ONLY: 'Buy now',
};

export const NewAuctionStatusTypeName = {
  TRYING_TO_DEAL: 'Trying to Deal',
  MINIMUM_PRICE: 'No Reserve',
  PHYSICAL: 'Reserve',
};

export const AvailableAuctionStatuses = [
  AuctionStatusType.MINIMUM_PRICE,
  AuctionStatusType.PHYSICAL,
];
